// @ts-check

import * as uuid from 'uuid';

/**
 * rcmGuid
 *
 * @type {import('./types').RcmGuid}
 * @deprecated use 'uuid' package
 */
const rcmGuid = {
  /**
   * @deprecated
   */
  generate: () => uuid.v4(),
};

window.rcmGuid = rcmGuid;

export default rcmGuid;
